// styles.js (updated, no makeStyles)
const useStyles = () => ({
  card: {
    maxWidth: '100%',
  },
  media: {
    paddingTop: '0%', // 16:9 ratio placeholder
  },
  avatar: {
    backgroundColor: 'transparent',
    width: '100px',
  },
  top: {
    marginTop: 10, // You can use numbers, theme.spacing(1) converts to 8px by default
  },
  grow: {
    flexGrow: 1,
  },
  btn: {
    color: 'black',
  },
  appbar: {
    background: "#152C73",
  },
  footer: {
    background: '#152C73',
  },
  title: {
    // flexGrow: 1,
    fontFamily: '-webkit-', // You might want to specify a font family or remove
    display: "flex", 
    alignContent: "center", 
    fontSize: "1.5rem"
  },
  uploadBox: {
    float: 'left',
    margin: 15,
    width: '100%',
  },
  infobox: {
    float: 'left',
    margin: 15,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: "8px", // replacing theme.spacing(1)
  },
  submit: {
    margin: "24px 0 16px", // replacing theme.spacing(3,0,2)
    background: "#152C73",
  },
  uploadpanel: {
    height: 250,
  },
  downloadsPanel: {
    width: '40%',
  },
  rootgrid: {
    width: '90%',
    right: 0,
    left: 0,
    margin: 'auto',
  },
  noPadding: {
    padding: '0 !important',
    borderRadius: 7,
    border: '2px solid #a3c8edc9',
    marginRight: 50,
  },
  formControl: {
    margin: "8px", // theme.spacing(1)
    minWidth: 280,
  },
  paper: {
    padding: "16px", // theme.spacing(2)
    marginBottom: "16px", // theme.spacing(2)
    marginTop: "1rem",
  },
  selectformControl: {
    margin: "8px", // theme.spacing(1)
    width: 280,
  },
  dropzonearea: {
    minHeight: 185,
  },
  space: {
    width: 4,
    height: 'auto',
    display: 'inline-block',
  },
});

export default useStyles;
